import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { DateAdapter } from '@angular/material/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BrandOptions, CategoryOptions, MeasuringunitOptions, ProductOptions, SubCategoryOptions, VendorOptions } from 'app/_models/optionsList/options';
import { PurchaseOrders } from 'app/_models/purchaseOrders/purchase-orders';
import { UserModel } from 'app/_models/user-model';
import { CrudPurchaseOrderService } from 'app/_services/MasterCrudOps/crud-purchase-order.service';
import { OptionslistService } from 'app/_services/optionslist.service';
declare const swal: any;

@Component({
  selector: 'app-add-child-purchase-order',
  templateUrl: './add-child-purchase-order.component.html'
})
export class AddChildPurchaseOrderComponent implements OnInit{ 
 @Output() toggle = new EventEmitter();
 @Output() updatePoList = new EventEmitter();

  addChildPurchaseOrderForm: UntypedFormGroup | null = null;
  vendorOptions: VendorOptions[] = [];
  brandOptions: BrandOptions[] = [];
  measuringOptions: MeasuringunitOptions[] = [];
  productOptions: ProductOptions[] = [];
  categoryOptions: CategoryOptions[] = [];
  subCategoryOptions: SubCategoryOptions[] = [];
  today: Date;
  poNumber:string = "";
  poDetail:PurchaseOrders;
  pageNumber: number;
  pageSize: number;
  isAdminGroupUser:boolean = false;
  currentUser: UserModel;

  constructor(
    private readonly poService: CrudPurchaseOrderService,
    private readonly optionslistService: OptionslistService,
    private readonly formBuilder: UntypedFormBuilder,
    private readonly dateAdapter: DateAdapter<Date>,
    public datepipe: DatePipe,
     private readonly dialogRef: MatDialogRef<AddChildPurchaseOrderComponent>,
     @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.today = new Date();
    this.dateAdapter.setLocale("en-GB");
    this.poDetail = data.poDetail;
     this.pageNumber = data.pageNumber;
    this.pageSize = data.pageSize;
    this.poNumber = this.poDetail.poNumber;
     this.currentUser = JSON.parse(sessionStorage.getItem("user"));
    this.isAdminGroupUser = this.currentUser.isAdminGroupUser;
  }
//poDetail
  ngOnInit(): void {
    this.addChildPurchaseOrderForm = this.formBuilder.group({
      poNumber: new UntypedFormControl("", [
        Validators.required,
        Validators.maxLength(50),
      ]),
      parntPurchaseOrderId: new UntypedFormControl(),
      orderDate: new UntypedFormControl("", [Validators.required]),
      vendorCode: new UntypedFormControl("", [Validators.required]),
      address: new UntypedFormControl("", [
        Validators.required,
        Validators.maxLength(250),
      ]),
      description: new UntypedFormControl("", [
        Validators.required,
        Validators.maxLength(100),
      ]),
      ChildPurchaseOrderDetails: new UntypedFormArray([]),
    });
    this.getVendorOptions();
    this.getProducts();
    this.getBrandOptions();
    this.getmeasuringUnits();
    this.addChildPurchaseOrderDetailForms();
  }
 getProducts() {
    this.optionslistService.getProductsOptions().subscribe((pro) => {
      this.productOptions = pro;
    });
  }

  getVendorOptions() {
    this.optionslistService.getVendorOptions().subscribe((data) => {
      this.vendorOptions = data;
    });
  }

  getBrandOptions() {
    this.optionslistService.getBrandOptions().subscribe((brands) => {
      this.brandOptions = brands;
    });
  }

  getmeasuringUnits() {
    this.optionslistService.getMeasuringunitOptions().subscribe((units) => {
      this.measuringOptions = units;
    });
  }

  onProductSelectionchange(e) {
    this.optionslistService
      .getCategoryByProductOptions(e.value)
      .subscribe((categories) => {
        this.categoryOptions = categories;
      });
  }

  onCategorySelectionchange(e) {
    this.optionslistService
      .getSubCategoryByCategoryOptions(e.value)
      .subscribe((subcats) => {
        this.subCategoryOptions = subcats;
      });
  }

  addChildPurchaseOrderDetailForms(): void {
    let orderDetailForm = new UntypedFormGroup({
      productId: new UntypedFormControl(null, [Validators.required]),
      categoryId: new UntypedFormControl(null, [Validators.required]),
      subcategoryId: new UntypedFormControl(null, [Validators.required]),
      brandId: new UntypedFormControl(null, [Validators.required]),
      orderQuantity: new UntypedFormControl("", [
        Validators.required,
        Validators.min(1),
        Validators.max(90000),
      ]),
      warrantyInMonths: new UntypedFormControl("", [
        Validators.required,
        Validators.min(0),
        Validators.max(60),
      ]),
      measuringUnitId: new UntypedFormControl(null, [Validators.required]),
      unitPrice: new UntypedFormControl(null, [
        Validators.required,
        Validators.min(0),
      ]),
    });
    (<UntypedFormArray>(
      this.addChildPurchaseOrderForm.get("ChildPurchaseOrderDetails")
    )).push(orderDetailForm);
  }

  saveChildPurchaseOrder() {
    swal({
      title: "Are you sure?",
      text: "A purchase order with details would be saved!",
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: "btn btn-success",
      cancelButtonClass: "btn btn-danger",
      confirmButtonText: "Save",
    }).then((result) => {
      if (result) {
        let poDetails = {
          poNumber: this.addChildPurchaseOrderForm.value.poNumber,
          orderDate: this.datepipe.transform(
            this.addChildPurchaseOrderForm.value.orderDate,
            "yyyy-MM-dd"
          ),
          vendorCode: this.addChildPurchaseOrderForm.value.vendorCode,
          address: this.addChildPurchaseOrderForm.value.address,
          description: this.addChildPurchaseOrderForm.value.description,
          parntPurchaseOrderId:this.poDetail.findiPurchaseOrderId,
          addPurchaseOrderDetailDtos: this.addChildPurchaseOrderForm.value.ChildPurchaseOrderDetails,
        };
        this.poService.savePurchaseOrder(poDetails).subscribe(
          (data) => {
            if (!data.didError) {
              //data saved successfully
              this.addChildPurchaseOrderForm.reset();
              this.toggle.emit({ args: true });
              this.updatePoList.emit({ args: true });
              swal({
                title: "",
                text: data.message,
                type: "success",
                confirmButtonClass: "btn btn-info",
              });
              this.dialogRef.close(true);

            } else {
              swal({
                title: data.message,
                text: data.additionalMessage,
                type: "error",
                confirmButtonClass: "btn btn-info",
              });
            }
          },
          (error) => {
            let errorMessage =
              error.error?.title ??
              error.error ??
              "Something went wrong. Please contact admin.";
            // Check if it's a validation error response with the `errors` object
            if (error.error?.errors) {
              const allErrors = Object.values(error.error.errors).flat(); // Flatten all error arrays
              if (allErrors.length > 0) {
                errorMessage = allErrors[0]; // Use the first validation message
              }
            } else if (typeof error.error === "string") {
              errorMessage = error.error;
            } else if (error.error?.title) {
              errorMessage = error.error.title;
            }
            swal({
              title: "",
              text: errorMessage,
              type: "error",
              confirmButtonClass: "btn btn-info",
            });
          }
        );
      }
    });
  }

  addDetailItem(): void {
    let formGroup = new UntypedFormGroup({
      productId: new UntypedFormControl(null, [Validators.required]),
      categoryId: new UntypedFormControl(null, [Validators.required]),
      subcategoryId: new UntypedFormControl(null, [Validators.required]),
      brandId: new UntypedFormControl(null, [Validators.required]),
      orderQuantity: new UntypedFormControl("", [
        Validators.required,
        Validators.min(1),
      ]),
      warrantyInMonths: new UntypedFormControl("", [
        Validators.required,
        Validators.min(0),
      ]),
      measuringUnitId: new UntypedFormControl(null, [Validators.required]),
      unitPrice: new UntypedFormControl(null, [
        Validators.required,
        Validators.min(0.1),
      ]),
    });
    (<UntypedFormArray>(
      this.addChildPurchaseOrderForm.get("ChildPurchaseOrderDetails")
    )).push(formGroup);
  }

  onRemoveDetailItem(index: number) {
    swal({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: "btn btn-success",
      cancelButtonClass: "btn btn-danger",
      confirmButtonText: "YES, Remove IT!",
    }).then((result) => {
      if (result === true) {
        (<UntypedFormArray>(
          this.addChildPurchaseOrderForm.get("ChildPurchaseOrderDetails")
        )).removeAt(index);
      }
    });
  }

  closechild()
  {
    this.dialogRef.close(true);
  }
 
  
}
